<template>
  <div>
    <BlNavBarMv title="Lembaga Pelatihan" has-back-button style="border-bottom: 1px solid #ebebeb" @handleBackButtonClick="toLandingPage" />

    <PrakerjaListWithIconError
      v-if="isError.merchants"
      info="Yah, infonya belum berhasil dimuat. Silakan coba muat ulang, ya."
      class="fullheight qa-error-merchant-list"
      @reload="fetchMerchants"
    />
    <template v-else>
      <PrakerjaListWithIcon
        v-if="!isAppLoading && merchantList.length"
        :list="merchantList"
        more-button-link="merchants"
        class="qa-prakerja-tab-content-merchants mt-20"
      />
      <PrakerjaListWithIconShimmer v-else :count="20" />
    </template>

    <BlFlexContainerMv
      align-items="center"
      direction="row"
      justify-content="flex-start"
      padding="16px 24px 32px 24px"
      style="background-color: #3a5fd6"
      class="mt-20 relative overflow-hidden register-cta"
    >
      <BlFlexItemAv class="relative">
        <IconPromoAnnouncement />
      </BlFlexItemAv>
      <BlFlexItemAv shrink="1" class="pl-16">
        <BlTextAv variation="caption-12" class="text-white">25+ LPK telah bergabung bersama kami. Lembaga kamu selanjutnya?</BlTextAv>
        <BlButtonAv
          href="https://www.bukalapak.com/promo-campaign/daftar-mitra-prakerja-bukalapak "
          variation="outline"
          size="small"
          class="mt-8"
          >Daftar sekarang</BlButtonAv
        >
      </BlFlexItemAv>
    </BlFlexContainerMv>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlButtonAv, BlNavBarMv} from '@bukalapak/bazaar-mweb-latest';
import PrakerjaListWithIcon from '../components/PrakerjaLandingPage/PrakerjaListWithIcon';
import PrakerjaListWithIconShimmer from '../components/PrakerjaLandingPage/PrakerjaListWithIconShimmer';
import PrakerjaListWithIconError from '../components/PrakerjaLandingPage/PrakerjaListWithIconError';

import IconPromoAnnouncement from 'public/images/kartu-prakerja/promo_announcement.svg';
import trackerGenerator from '../mixins/tracker-generator';
import {TRACKER_EVENT_VP_PRAKERJA_MERCHANT_COURSES} from '../config/tracker-events';

export default {
  name: 'PrakerjaMerchantListPage',
  components: {
    BlNavBarMv,
    BlButtonAv,
    PrakerjaListWithIcon,
    PrakerjaListWithIconShimmer,
    IconPromoAnnouncement,
    PrakerjaListWithIconError,
  },
  mixins: [trackerGenerator],
  computed: {
    ...mapGetters(['isAppLoading']),
    ...mapGetters({
      merchantList: 'merchants/getMerchants',
      isError: 'getError',
    }),
  },
  beforeMount() {
    this.initMerchantListPage();
  },
  methods: {
    initMerchantListPage() {
      window.scrollTo(0, 0);

      this.fetchMerchants();
      this.trackPrakerjaMerchant();
    },
    fetchMerchants() {
      this.$store.commit('categories/setSelectedCategory', 'all');
      this.$store.dispatch('merchants/fetchMerchants');
    },
    toLandingPage() {
      this.$router.push({name: 'landing', query: this.$route.query});
    },
    trackPrakerjaMerchant() {
      const payload = {
        session_id: this.$root.mixinSessionId,
      };

      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_MERCHANT_COURSES, payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.fullheight {
  height: calc(100vh - 180px);
}

.register-cta::before {
  content: '';
  position: absolute;
  width: 129px;
  height: 129px;
  border-radius: 50%;
  background-color: #4f78e8;
  left: -34px;
  top: -34px;
}
</style>
